import React, { Component } from 'react';
import Axios from 'axios';
import './Feedback.css';

import Config from '../../../base/config/Config';
import Session from '../../../base/Session';
import Utils from '../../../base/Utils';

import Title from './../../components/title/Title';
import Description from './../../components/description/Description';
import Input from './../../components/input/Input';
import Button from './../../components/button/Button';
import SmallText from './../../components/smallText/SmallText';
import Icon from './../../components/icon/Icon';


class Feedback extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            canSubmit: false,
            submitting: false,
            successfullySubmitted: null,
        };
    }
    
    render() {
        var canSubmit = this.state.canSubmit;
        var submitting = this.state.submitting;
        var successfullySubmitted = this.state.successfullySubmitted;
        
        return <div className="WidthLimit">
        <div className="Column-D1">
        <Title text="Feedback" type="Underlined" size="Big" />
        <Description text="Send us feedback in case of bugs or erros with our API." />
        </div>
        <div className="Spacer"></div>
        <div className="Column-D1_5">
        <Input placeholder="Add Contact Email" label="Email *" type="email"
        value={Session.getParams().email} getRef={(input) => this.emailInput = input} onChange={() => this.checkFeedbackFill()}
        clearCallback={(callback) => { this.feedbackClears.email = callback }} />
        </div>
        <div className="Column-D3">
        <Input placeholder="Add Date" label="Last Working Date *" type="date"
        getRef={(input) => this.errorDateInput = input} onChange={() => this.checkFeedbackFill()}
        clearCallback={(callback) => { this.feedbackClears.errorDate = callback }} />
        </div><br /><br />
        <div className="Column-D1">
        <Input placeholder="The error you are receiving in the response" label="Type of error *"
        getRef={(input) => this.errorTypeInput = input} onChange={() => this.checkFeedbackFill()}
        clearCallback={(callback) => { this.feedbackClears.errorType = callback }} /><br /><br />
        <Input placeholder="Add a Title" label="Title *"
        getRef={(input) => this.titleInput = input} onChange={() => this.checkFeedbackFill()}
        clearCallback={(callback) => { this.feedbackClears.title = callback }} /><br /><br />
        <Input placeholder="Describe your error in detail" label="Description *" type="textarea" height="250"
        getRef={(input) => this.descriptionInput = input} onChange={() => this.checkFeedbackFill()}
        clearCallback={(callback) => { this.feedbackClears.description = callback }} />
        <div className="Spacer"></div>
        <div className="Column-D2 NoMargin">
        <SmallText text="* Required fields" color="Bad" />
        </div>
        <div className="Column-D2 NoMargin" style={{textAlign:'right'}}>
        <Button text={(successfullySubmitted === null) ? "Send Feedback" : 
        <span>{(successfullySubmitted) ? <Icon set="Check Mark" color="Good" size="Medium" /> : 
        <Icon set="Delete" color="Bad" size="Medium" /> }</span>} type="Normal" size="Small" 
        state={(canSubmit && successfullySubmitted === null) ? "Normal" : "Disabled"} 
        loading={submitting} onClick={() => this.submitFeedback()} />
        </div>
        </div>
        <div className="Spacer"></div>
        <div className="Spacer"></div>
        <div className="Spacer"></div>
        </div>;
    }
    
    emailInput = null;
    errorDateInput = null;
    errorTypeInput = null;
    titleInput = null;
    descriptionInput = null;
    
    feedbackClears = {};
    
    getFeedbackParams() {
        return {
            email: this.emailInput.value.trim(),
            errorDate: this.errorDateInput.value.trim(),
            errorType: this.errorTypeInput.value.trim(),
            title: this.titleInput.value.trim(),
            description: this.descriptionInput.value.trim()
        };
    }
    
    clearFeedbackInputs() {
        Object.keys(this.feedbackClears).map((index) => {
            return this.feedbackClears[index]();
        });
    }
    
    checkFeedbackFill() {
        var params = this.getFeedbackParams();
        
        if(Utils.validateEmail(params.email) && params.email !== '' && params.errorDate !== '' && 
        params.errorType !== '' && params.title !== '' && params.description !== '') {
            this.setState({canSubmit: true});
        } else {
            this.setState({canSubmit: false});
        }
    }
    
    submitFeedback() {
        this.setState({submitting: true});
        
        Axios.post(Config.backendHost + "api/feedback", this.getFeedbackParams(), {withCredentials: true}).then((response) => {
            if(Utils.checkResponse(response)) {
                var data = response.data;
                
                if(data.status === 'success') {
                    this.setState({submitting: false, successfullySubmitted: true});
                    this.restoreSubmitButton();
                    return;
                }
            }
            
            this.setState({submitting: false, successfullySubmitted: false});
            this.restoreSubmitButton();
        }).catch((err) => {
            this.setState({submitting: false, successfullySubmitted: false});
            this.restoreSubmitButton();
        });
    }
    
    restoreSubmitButton() {
        setTimeout(() => {
            this.setState({successfullySubmitted: null});
        }, 3000);
    }
}

export default Feedback;
